module.exports = __webpack_public_path__ + "catarse--0b72d36f.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/parceiros/catarse.png
// module id = 232
// module chunks = 0